// extracted by mini-css-extract-plugin
export default {"root":"FrameViewer_root__R88Hs","frame":"FrameViewer_frame__Uu5pn"};